import { Order } from '@mews-commander/data-access';

const sortKeyMap = {
    associatedAccountName: 'associatedAccount',
    ownerName: 'owner',
    billName: 'bill',
};
type Sort = Record<string, { order: Order; priority: number }> | {};

export const getOrderFromSort = (sort: Sort) => {
    const [columnKey, columnValue] = Object.entries(sort)[0] || [];
    const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
    const sortKey = (columnKey && (sortKeyMap as Record<string, string>)[columnKey]) || columnKey;
    const orderBy = sortKey ? capitalize(sortKey) : undefined;

    return {
        orderBy,
        order: columnValue?.order,
    };
};
